import { OutlinedInput } from "@mui/material";
import { countries } from "../../helpers/CountriesISO";
import "../../helpers/flags.scss";
import { Control, Controller, FieldValues } from "react-hook-form";

type Props = {
  id: string;
  label: string;
  restProps: any;
  errors: any;
  countryCode: number;
  control: Control<FieldValues, any>;
  setCountryCode: React.Dispatch<React.SetStateAction<number>>;
};

const PhonePicker = ({
  id,
  label,
  restProps,
  setCountryCode,
  countryCode,
  control,
  errors,
}: Props) => {
  const handleCountryCodeChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setCountryCode(Number(event.target.value));
  };

  return (
    <div className="flex gap-[10px] flex-col">
      <label htmlFor={id} className="">
        {label}
      </label>
      <div className="flex items-center">
        <div className="relative w-full">
          <Controller
            name={id}
            control={control}
            render={(field) => {
              return (
                <OutlinedInput
                  type="number"
                  id="phone-input"
                  className="bg-white rounded-none w-full"
                  {...field.field}
                  startAdornment={
                    <select
                      className="flex-shrink-0 px-4 w-[60px] h-12 text-sm appearance-none mr-0 focus:outline-none rounded-l-[4px] "
                      value={countryCode}
                      onChange={handleCountryCodeChange}
                    >
                      {Object.values(countries).map((country) => {
                        return (
                          <option
                            key={`country_option_${country["alpha-2"]}`}
                            value={country.country_code}
                          >
                            + {country.country_code} {country.name}{" "}
                          </option>
                        );
                      })}
                    </select>
                  }
                  // required
                />
              );
            }}
          />
        </div>
      </div>
      <div className="text-red-600 text-sm cursor-default">
        {errors[id]?.message}
      </div>
    </div>
  );
};

export default PhonePicker;
